/**
 * Return the currently available inventory for an oocyte cohort.
 *
 * Cohort counts are API-level quantities. The member specimens are a
 * compatibility fan-out and must not be counted as the cohort quantity.
 */
export function getRemainingOocyteCohortCount(
  numberFrozen: number | null | undefined,
  numberThawed: number | null | undefined,
  fallbackFrozenCount: number,
): number {
  const frozen = Math.max(0, numberFrozen ?? fallbackFrozenCount);
  const thawed = Math.max(0, numberThawed ?? 0);
  return Math.max(0, frozen - Math.min(frozen, thawed));
}
